/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { createGetPromptVersionGraphsService } from '../../../../common/prompt/createPromptV2Services';
import * as constants from '../../constants/AgenticServiceConstants';
import { PROMPT_MANAGEMENT_LANG_KEYS } from '../../constants/AgenticPromptMgmtConstants';

export default createGetPromptVersionGraphsService({
  eventName: constants.GET_PROMPT_VERSION_GRAPHS,
  statusKey: 'GetPromptVersionGraphsServiceStatus',
  storeName: 'agenticPromptModel',
  errorLangKey: PROMPT_MANAGEMENT_LANG_KEYS.ERROR_ASSOCIATED_GRAPHS,
  errorEvent: constants.GET_PROMPT_VERSION_GRAPHS_ERROR
});
